<script>
// https://github.com/TerryZ/v-suggest/issues/14

// import {Suggest} from 'v-suggest'
import {Suggest} from 'v-suggest/src/index'

export default {
  extends: Suggest,
  watch: {
    data (newValue, oldValue) {
      this.focus()
    }
  }
}
</script>
